import Styles from './DashboardToolsSection.module.scss';
import {FiFlag as FlagIcon} from 'react-icons/fi';
import {tools} from './consts';
import {Tool, Link} from './types';

export const DashboardToolsSection = () => (
  <div className={Styles.wrapper}>
    <h1 className={Styles.header}>
      <FlagIcon size={28} />
      Integrations
    </h1>
    <div className={Styles.content}>
      {tools.map(({image, title, description, links}: Tool) => (
        <div key={title} className={Styles.tool}>
          <div className={Styles.image}>
            <img src={image} alt={title} />
          </div>
          <div className={Styles.info}>
            <h2 className={Styles.title}>{title}</h2>
            <p className={Styles.description}>{description}</p>
            <ul className={Styles.links}>
              {links.map(({text, href}: Link) => (
                <li key={text} className={Styles.linkItem}>
                  <a href={href} target="_blank" rel="noreferrer" className={Styles.link}>
                    {text}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      ))}
    </div>
  </div>
);
